import { ContactDataDisplayModelFormGroup } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '@/core/services/state.service';
import { ContactDataDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { AnfrageService } from '@/api/service-index';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { AnfrageNavigationFormComponent, MoveDirection } from '../../../../components/anfrage-navigation-form/anfrage-navigation-form.component';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { GlobalEnumerationsAceIdentischmit, UpdateAnfrageAnsprechpersonDataCommand, UpdateAnfrageVertretungsberechtigterDataCommand } from '@/api/model-index';

@Component({
    selector: 'vertretungsberechtigte-form-process-step',
    templateUrl: './vertretungsberechtigte-form-process-step.component.html',
    styleUrls: ['./vertretungsberechtigte-form-process-step.component.scss'],
    standalone: false
})
export class VertretungsberechtigteFormProcessStepComponent extends AnfrageNavigationFormComponent {
    public contactDataProcessStepForm: ContactDataDisplayModelFormGroup;
    public contactData: ContactDataDisplayModel;

    public get formGroup(): FormGroup<any> {
        return this.contactDataProcessStepForm;
    }

    constructor(protected route: ActivatedRoute,
        protected router: Router,
        protected sectionService: SectionService,
        protected anfrageService: AnfrageService,
        protected stateService: StateService,
        protected portalContextService: PortalContextService,
        protected loadingAnimationService: LoadingAnimationService,
        protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) {

        super(sectionService, router, route, portalContextService);

        this.contactData = this.route.snapshot.data.contactData;
        this.contactDataProcessStepForm = ContactDataDisplayModelFormGroup.Instance

        this.contactDataProcessStepForm.patchValue(this.contactData);
    }

    protected save(shouldSave: boolean, moveDirection: MoveDirection): void {

        if (shouldSave && this.contactDataProcessStepForm.dirty) {
            this.contactData = this.contactDataProcessStepForm.getRawValue();

            if (this.contactDataProcessStepForm.CbweitererVertretungsberechtigter.value !== true) {
                this.contactData.cbweitererVertretungsberechtigter = false;
                delete this.contactData.weitererVertretungsberechtigter;
            }

            delete this.portalContextService.CurrentAnfrage.contactData;
            this.contactDataProcessStepForm.markAsPristine();
            if (moveDirection != MoveDirection.STAY) {
                if (this.canceledRoute) {
                    this.router.navigateByUrl(this.canceledRoute);
                } else {
                    this.move(moveDirection);
                }
            }

            let updateCommand = new UpdateAnfrageVertretungsberechtigterDataCommand()
            updateCommand.vertretungsberechtigter = this.contactData.vertretungsberechtigter;
            updateCommand.weitereVertretungsberechtigter = this.contactData.weitererVertretungsberechtigter;
            updateCommand.cbweitererVertretungsberechtigter = this.contactData.cbweitererVertretungsberechtigter;

            let subscription = this.anfrageService.apiAnfrageAnfrageIdContactDataVertretungsberechtigtePatch({ anfrageId: this.anfrage.id, body: updateCommand })
                .subscribe(() => {
                    this.anfrageService.apiAnfrageAnfrageIdContactDataGet({ anfrageId: this.anfrage.id }).subscribe(response => {
                        if (response) {
                            this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
                                this.stateService.ValidationErrors = result;
                            })

                            if (this.portalContextService.CurrentAnfrage)
                                this.portalContextService.CurrentAnfrage.contactData = response;

                            this.contactDataProcessStepForm.patchValue(response);
                            this.contactDataProcessStepForm.markAsPristine();
                        }
                    });
                }, (error) => {
                    this.contactDataProcessStepForm.markAsDirty();
                    throw error;
                });
            this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
            this.unfinishedHttpMethodsService.addSubscription(subscription);
        } else {
            this.contactDataProcessStepForm.markAsPristine();
            this.move(moveDirection);
        }
    }
}
